import React from "react";
import { IKImage } from "imagekitio-react";
import { allFooterLinks } from "../../../components/Footer/links";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { helpReason, timeToCall } from "../PricingAnnual/GetHelpInfo";
import { useSelector } from "react-redux";
import { SupportRequest } from "../../../redux/actions/pricing";
import { Dialog, Transition, Listbox } from "@headlessui/react";
import { toast } from "react-toastify";
import './index.css'

const CoinModal = ({ isModalEnabled, setIsModalEnabled }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [careerGoal, setCareerGoal] = useState(helpReason[1]);
  const [timing, setTiming] = useState(timeToCall[2]);
  const [age, setAge] = useState("");
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const [isSubmit, setIsSubmit] = useState(false);
  function onSubmit() {
    if (typeof age != "string") {
      toast.error("Enter Valid Age", {
        closeButton: false,
      });
    } else if (
      !isNaN(age) &&
      parseInt(Number(age)) == age &&
      !isNaN(parseInt(age, 10)) &&
      parseInt(Number(age)) > 0
    ) {
      dispatch(
        SupportRequest(user_id, age, careerGoal, timing, (successObj) => {
          console.log(successObj);
          setIsSubmit(true);
        })
      );
    } else {
      toast.error("Enter Valid Age", {
        closeButton: false,
      });
    }
  }
  if (isSubmit === false) {
    return (
      <Dialog
        open={isModalEnabled}
        onClose={() => setIsModalEnabled(!isModalEnabled)}
        as="div"
        className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-10 flex w-4/5 flex-col items-start justify-start rounded-2xl bg-white px-5 py-7 shadow-2xl md:w-3/5  lg:w-1/5">
          <div>
            <h1 className="mb-5 text-xl font-bold">
              Answer these questions for us to help you.
            </h1>
            <label className="text-sm font-medium after:text-red-700 after:content-['*']">
              How old are you?
            </label>
            <input
              type="text"
              className=" mb-3 w-full rounded-md  border-gray-300"
              value={age}
              onChange={(event) => {
                setAge(event.target.value);
              }}
            ></input>
            <label className="text-sm font-medium ">
              What is your current career goal?
            </label>
            <div className="mb-3 w-full ">
              <Listbox
                as="div"
                className=""
                value={careerGoal}
                onChange={setCareerGoal}
              >
                {({ open }) => (
                  <>
                    <div className="relative z-[9999]">
                      <span className="inline-block w-full rounded-md shadow-sm">
                        <Listbox.Button className="focus:shadow-outline-blue relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left transition duration-150 ease-in-out focus:border-blue-300 focus:outline-none sm:text-sm sm:leading-5">
                          <span className="block truncate">{careerGoal}</span>
                          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <svg
                              className="h-5 w-5 text-gray-400"
                              viewBox="0 0 20 20"
                              fill="none"
                              stroke="currentColor"
                            >
                              <path
                                d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </Listbox.Button>
                      </span>

                      <Transition
                        show={open}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                      >
                        <Listbox.Options
                          static
                          className="shadow-xs max-h-60 overflow-auto rounded-md py-1 text-base leading-6 focus:outline-none sm:text-sm sm:leading-5"
                        >
                          {helpReason.map((reason) => (
                            <Listbox.Option value={reason}>
                              {({ selected, active }) => (
                                <div
                                  className={`${
                                    active
                                      ? "bg-blue-600 text-white"
                                      : "text-gray-900"
                                  } relative cursor-default select-none py-2 pl-8 pr-4`}
                                >
                                  <span
                                    className={`${
                                      selected ? "font-semibold" : "font-normal"
                                    } block truncate`}
                                  >
                                    {reason}
                                  </span>
                                  {selected && (
                                    <span
                                      className={`${
                                        active ? "text-white" : "text-blue-600"
                                      } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                    >
                                      <svg
                                        className="h-5 w-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </div>
            <label className="text-sm font-medium ">
              When can our career expert call you?
            </label>
            <div className="mb-3 w-full">
              <Listbox
                as="div"
                className=""
                value={timing}
                onChange={setTiming}
              >
                {({ open }) => (
                  <>
                    <div className="relative">
                      <span className="inline-block w-full rounded-md shadow-sm">
                        <Listbox.Button className="focus:shadow-outline-blue relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left transition duration-150 ease-in-out focus:border-blue-300 focus:outline-none sm:text-sm sm:leading-5">
                          <span className="block truncate">{timing}</span>
                          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <svg
                              className="h-5 w-5 text-gray-400"
                              viewBox="0 0 20 20"
                              fill="none"
                              stroke="currentColor"
                            >
                              <path
                                d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </Listbox.Button>
                      </span>

                      <Transition
                        show={open}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                      >
                        <Listbox.Options
                          static
                          className="shadow-xs max-h-60 overflow-auto rounded-md py-1 text-base leading-6 focus:outline-none sm:text-sm sm:leading-5"
                        >
                          {timeToCall.map((time) => (
                            <Listbox.Option value={time}>
                              {({ selected, active }) => (
                                <div
                                  className={`${
                                    active
                                      ? "bg-blue-600 text-white"
                                      : "text-gray-900"
                                  } relative cursor-default select-none py-2 pl-8 pr-4`}
                                >
                                  <span
                                    className={`${
                                      selected ? "font-semibold" : "font-normal"
                                    } block truncate`}
                                  >
                                    {time}
                                  </span>
                                  {selected && (
                                    <span
                                      className={`${
                                        active ? "text-white" : "text-blue-600"
                                      } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                    >
                                      <svg
                                        className="h-5 w-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </div>
          </div>
          <div className="mt-5 flex w-full flex-row self-center">
            <button
              className="mr-1 w-1/2 rounded-3xl border-2 border-pricing_blue px-2 py-2 text-sm"
              onClick={(event) => {
                setIsModalEnabled(false);
              }}
            >
              Cancel
            </button>
            <button
              className="ml-1 w-1/2 rounded-3xl px-2 py-2  text-sm text-white button-background-gradient"
              onClick={(event) => onSubmit()}
            >
              Submit
            </button>
          </div>
        </div>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={isModalEnabled}
        onClose={() => setIsModalEnabled(!isModalEnabled)}
        as="div"
        className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="z-10 flex w-4/5 flex-col items-start justify-start rounded-2xl bg-white px-5 py-5 shadow-2xl md:w-3/5  lg:w-1/5">
          <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src={
              "https://assets.learntube.ai/files/PRICING/image.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662470138101"
            }
            transformation={[
              {
                height: "100",
                width: "100",
              },
            ]}
            className="mt-2 mb-2 h-24"
          />
          <div className="text-xl font-bold">
            Our Career Experts Will Call You Soon
          </div>
          <button
            className="ml-1 mt-3 w-3/4 self-end rounded-3xl px-2 py-2  text-xs text-white button-background-gradient"
            onClick={(event) => {
              setIsModalEnabled(false);
            }}
          >
            Continue Exploring Plans
          </button>
        </div>
      </Dialog>
    );
  }
};

export default CoinModal;
